import React from "react";
import { CHALLENGE } from "../../../../common/challengeConstants";

const QuizBadgeDetail = () => <p>
  {CHALLENGE.badges.QuizHeading}<br />
  {CHALLENGE.badges.QuizSubHeading}
</p>
export default QuizBadgeDetail;